import styled from "styled-components";
import { theme } from "../../styles/theme";

export const WrapperLayout = styled.div`
  display: flex;
  width: 100vw;
  min-height: 100vh;
  overflow-y: auto;
  overflow-x: hidden;
  flex-direction: column;
  
  @media (max-width: ${theme.breakpoints.sm}) {
    min-height: 100vh;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    padding-bottom: 20px;
    
    @supports (-webkit-appearance: none) {
      padding-bottom: 60px !important;
    }
  }
`;

export const Navbar = styled.div`
  display: flex;
  height: 70px;
  width: 100%;
  padding: 0 97px 0 97px;
  justify-content: space-between;
  align-items: center;
  background: ${theme.colors.white} 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 13px #00000008;
  border-radius: 0px 0px 20px 20px;
  opacity: 1;

  @media (max-width: ${theme.breakpoints.sm}) {
    height: 56px;
    padding: 0 21px;
  }
`;
